module.exports = __webpack_public_path__ + "img/Bitmap4.3690ebc0.png";